/**
 * Restaurant Configuration
 * This file contains all customizable data for the restaurant website
 */

export const restaurantConfig = {
    // Basic Info
    name: "NoPatio",
    tagline: {
        en: "Italian Cuisine & Wine Bar",
        pt: "Cozinha Italiana & Wine Bar"
    },
    // Restaurant image, displayed on hero section
    restaurantImage: "/images/hero-bg.jpg",
    // Logo image, displayed on header
    logoImage: "/images/logo.png",
    // Light Logo image (for transparent navbar)
    logoImageLight: "/images/logo-light.png",
    // Restaurant founding year, used on About section
    foundingYear: 1995,

    contact: {
        // Address, displayed on several places, including header, about and footer
        address: "Rua Lançarote de Freitas 46,São Gonçalo de Lagos , 8600-605 Lagos",
        // Embedding map from Google Maps
        mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3177.0557553154686!2d-8.675993223588824!3d37.099276157748186!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1b31c11525033d%3A0xf832d85eacaa007b!2sRestaurante%20No%20Patio!5e0!3m2!1sen!2spt!4v1714487744635!5m2!1sen!2spt",
        // Email for CONTACT form, displayed on header and footer
        email: "rest.nopatio@gmail.com",
        // Phone for contact, reservations
        phone: "282763777",
        // Opening hours
        businessHours: {
            en: [
                "Tuesday - Saturday: 18:30 - 21:30"
            ],
            pt: [
                "Terça-feira - Sábado: 18:30 - 21:30"
            ]
        }
    },

    // For backward compatibility with components still using these properties
    address: {
        en: "R. Lançarote de Freitas 46, 8600-632 Lagos",
        pt: "R. Lançarote de Freitas 46, 8600-632 Lagos"
    },
    email: "rest.nopatio@gmail.com",
    phone: "282763777",
    businessHours: {
        en: [
            "Tuesday - Saturday: 18:30 - 21:30"
        ],
        pt: [
            "Terça-feira - Sábado: 18:30 - 21:30"
        ]
    },

    // Social Media
    social: {
        instagram: "https://www.instagram.com/nopatio",
        facebook: "https://www.facebook.com/nopatio",
        tripadvisor: "https://www.tripadvisor.com/Restaurant_Review-g189117-d1106049-Reviews-Restaurante_No_Patio-Lagos_Faro_District_Algarve.html",
        thefork: "https://www.thefork.pt/restaurante/restaurante-no-patio-r827550"
    },

    // Theme
    colors: {
        primary: "#C55E86", // Pink (flowers)
        secondary: "#4F4F4D", // Grey (text)
        accent: "#4c8a5a", // Green (plants)
        light: "#FFFFFF", // White
        dark: "#333333" // Dark Grey
    },

    // The Fork Reservation Widget (for testing)
    theForkWidget: {
        reservationUrl: "https://module.lafourchette.com/en_GB/module/759951-eb9f9",
        widgetId: "759951",
        restaurantId: "eb9f9"
    },

    // Menu Items Configuration
    menuItems: {
        entradas: [
            {
                name: { pt: "Carpaccio de Novilho", en: "Beef Carpaccio" },
                description: { 
                    pt: "com chutney de Alperce, amêndoas tostadas e Rúcula crocante", 
                    en: "with dried Apricot chutney, toasted Almonds and crispy Rúcula" 
                },
                price: "16.30",
                tags: []
            },
            {
                name: { pt: "Queijo de Cabra gratinado", en: "Gratinated Goat Cheese" },
                description: { 
                    pt: "com maçã assada, mel e nozes", 
                    en: "with baked Apple, Honey and Walnuts" 
                },
                price: "14.50",
                tags: []
            },
            {
                name: { pt: "Foie Gras", en: "Fried Foie Gras" },
                description: { 
                    pt: "com creme de cenoura e Figo ao Vinho do Porto", 
                    en: "with Carrot cream and fig in Port wine" 
                },
                price: "17.90",
                tags: []
            },
            {
                name: { pt: "Camarão Flambado em Brandy", en: "Flambeed Prawns in Brandy" },
                description: { 
                    pt: "com molho de queijo com alho e ervas", 
                    en: "with Cheese sauce, Garlic and Herbs" 
                },
                price: "16.50",
                tags: []
            },
            {
                name: { pt: "Espargos verdes grelhados", en: "Grilled green Asparagus" },
                description: { 
                    pt: "com Tomate seco, Cogumelos selvagens e Parmesão", 
                    en: "with sundried Tomatoes, wild Mushrooms and Parmesan Cheese" 
                },
                price: "14.40",
                tags: []
            },
            {
                name: { pt: "Sopa do Dia", en: "Soup of the Day" },
                description: { pt: "", en: "" },
                price: "8.50",
                tags: []
            },
            {
                name: { pt: "Couvert para 2", en: "Couvert for 2" },
                description: { pt: "", en: "" },
                price: "8.00",
                tags: []
            }
        ],
        doMar: [
            {
                name: { pt: "Corvina grelhada", en: "Grilled Corvina" },
                description: { 
                    pt: "com creme de couve flor, figos ao Porto e amêndoas tostadas", 
                    en: "with Cauliflower cream, fig in Port wine and toasted Almonds" 
                },
                price: "26.30",
                tags: []
            },
            {
                name: { pt: "Filet de Salmão", en: "Salmon Fillet" },
                description: { 
                    pt: "com risotto de cogumelos selvagens, tomate seco e espuma de Trufa", 
                    en: "with Mushroom Risotto and green Asparagus, Sun dried Tomato and Truffle foam" 
                },
                price: "23.50",
                tags: []
            },
            {
                name: { pt: "Seleção de peixe em Molho Exótico", en: "Fish Selection in Coconut Sauce" },
                description: { 
                    pt: "de coco com legumes assados e castanha de caju", 
                    en: "with roasted Vegetables and Cashew Nuts" 
                },
                price: "24.50",
                tags: []
            }
        ],
        doJardim: [
            {
                name: { pt: "Risoto de cogumelos e espargos verdes", en: "Mushroom and green Asparagus Risotto" },
                description: { 
                    pt: "com lascas de parmesão e óleo de Trufa", 
                    en: "with Parmesan shavings and Truffle oil" 
                },
                price: "21.50",
                tags: []
            },
            {
                name: { pt: "Ravioli caseiro de espinafre", en: "Spinach Ravioli" },
                description: { 
                    pt: "com molho de queijo azul, Pera ao Porto e amêndoas tostadas", 
                    en: "with blue Cheese Sauce, Pear in Port Wine and toasted Almonds" 
                },
                price: "23.90",
                tags: []
            },
            {
                name: { pt: "Polenta no forno", en: "Baked Polenta" },
                description: { 
                    pt: "com Legumes Salteados, chutney de Alperce e castanha de caju", 
                    en: "with sautéed Vegetables, dried Apricot chutney and Cashew Nuts" 
                },
                price: "19.90",
                tags: []
            }
        ],
        doCampo: [
            {
                name: { pt: "Peito de Pato", en: "Duck Breast" },
                description: { 
                    pt: "com creme de Cenoura, Crumble de Maçã e molho de Chocolate", 
                    en: "with Carrot cream, Apple crumble and Chocolate sauce" 
                },
                price: "27.50",
                tags: []
            },
            {
                name: { pt: "Lombo de Novilho", en: "National Beef fillet" },
                description: { 
                    pt: "com Cogumelos selvagem, Espargos verdes e molho de Whisky", 
                    en: "with wild Mushrooms, green Asparagus and Whisky sauce" 
                },
                price: "36.00",
                tags: []
            },
            {
                name: { pt: "Bochechas de Porco em baixa temperatura", en: "Slow cooked Pork Cheeks" },
                description: { 
                    pt: "puré de Couve flor e Pera ao Vinho do Porto", 
                    en: "with Cauliflower puree and Pear in Port wine" 
                },
                price: "28.50",
                tags: []
            },
            {
                name: { pt: "Carré de Borrego", en: "Lamb Rack" },
                description: { 
                    pt: "com Ervas e Alho, Polenta no Forno e Legumes", 
                    en: "with Herbs and Garlic, baked Polenta and sauteed Vegetables" 
                },
                price: "38.00",
                tags: []
            }
        ],
        sobremesa: [
            {
                name: { pt: "Bolo de Tâmaras com Caramelo", en: "Sticky Toffee Pudding" },
                description: { 
                    pt: "e molho de Baunilha", 
                    en: "with Custard sauce" 
                },
                price: "9.50",
                tags: []
            },
            {
                name: { pt: "Creme Brulee", en: "Creme Brulee" },
                description: { 
                    pt: "com frutos silvestres", 
                    en: "with Red berries" 
                },
                price: "8.90",
                tags: []
            },
            {
                name: { pt: "Creme de Mel e Canela", en: "Honey and Cinnamon cream" },
                description: { 
                    pt: "com molho de maracujá e Ameixas ao Vinho do Porto", 
                    en: "with Passion fruit sauce and Prunes in Port wine" 
                },
                price: "9.50",
                tags: []
            },
            {
                name: { pt: "Brownie de Chocolate", en: "Chocolate Brownie" },
                description: { 
                    pt: "com molho de Café, Gelado de Baunilha e crumble de Amendoim", 
                    en: "with Coffee Sauce, Vanilla Ice Cream and Peanut crumble" 
                },
                price: "9.30",
                tags: []
            },
            {
                name: { pt: "Seleção de Queijos", en: "Cheese Selection" },
                description: { 
                    pt: "com Bolachas e Geleia caseira", 
                    en: "with Crackers and home made Jam" 
                },
                price: "11.90",
                tags: []
            }
        ]
    },

    // Team Members
    team: [{
        name: "Captain Jack",
        role: {
            en: "Owner & Captain",
            pt: "Proprietário e Capitão"
        },
        bio: {
            en: "Born on the high seas, Captain Jack brings his love for the ocean and hospitality to PIRATA. His passion for excellent service and fresh seafood has created a unique beach bar experience.",
            pt: "Nascido no alto mar, o Capitão Jack traz seu amor pelo oceano e hospitalidade para o PIRATA. Sua paixão por excelente serviço e frutos do mar frescos criou uma experiência única de bar de praia."
        },
        image: "/images/captain.jpg"
    }],

    // About Section Content
    about: {
        en: "All the extravagance of Brazilian cuisine by Walkiria Reiter, combined with the refined elegance of European gastronomy by Sven Pachaly, brought together in one space — delivering an explosion of flavours and sensations, with each dish promising a different emotion.\nThey say love is something you feel. Here, we say: love is something you eat.\nShe, a girl raised on the farm, grew up around wood-fired stoves, learning early on that cooking is almost like alchemy.\nHe, trained in European culinary schools and seasoned in Michelin-starred restaurants, discovered that art lies in everything made with love — and that a dish can often be a canvas.\nThis fusion of cultures is, above all, a promise of an unforgettable experience.",
        pt: "Toda a extravagância da cozinha brasileira de Walkiria Reiter, unida à elegância refinada da cozinha europeia de Sven Pachaly, num só espaço que proporciona uma explosão de sabores e sensações — prometendo, em cada prato, uma emoção diferente.\nDiz-se por aí que o amor se sente. Aqui dizemos: o amor come-se.\nEla, menina criada nas fazendas, à volta dos fogões a lenha, aprendeu desde cedo que cozinhar é quase uma alquimia.\nEle, formado em escolas europeias e com experiência em restaurantes com estrela Michelin, descobriu que a arte está em tudo o que é feito com amor — e que um prato, muitas vezes, pode ser uma tela.\nEsta mistura de culturas é, no fundo, uma promessa de um momento inesquecível."
    },

    // Testimonials
    testimonials: [{
            name: "Jane Davis",
            location: {
                en: "Visitor",
                pt: "Visitante"
            },
            comment: {
                en: "Best restaurant of Lagos, romantic fine dining, great fish & vegan food 🌱👍🇵🇹\nFood: 5/5  |  Service: 5/5  |  Atmosphere: 5/5\n\nVegetarian options\nGreat vegetarian and vegan options on the menu, you will love it! ❤️",
                pt: "Melhor restaurante de Lagos, jantar romântico refinado, ótimos pratos de peixe e comida vegana 🌱👍🇵🇹\nComida: 5/5  |  Serviço: 5/5  |  Ambiente: 5/5\n\nOpções vegetarianas\nÓtimas opções vegetarianas e veganas no menu, você vai adorar! ❤️"
            },
            rating: 5,
            image: "/images/reviewers/reviewer1.jpg",
            isLocalGuide: false,
            sourceUrl: "https://maps.app.goo.gl/XVZMszuoXkPhCF3m9"
        },
        {
            name: "Maria Costa",
            location: {
                en: "Local Guide",
                pt: "Guia Local"
            },
            comment: {
                en: "Hidden gem in Lagos. Food was amazing and the atmosphere was so relaxed, perfect for a summer evening. The service was really good. Pictures : grill tuna with veggies and potatoes ( amazing taste ) and ravioli with pumpkin and cheese and vanilla and lemon. We spend 45-50 eur per person, with starters and a bottle of wine. It's the kind of place to go all our for a lovely night. For the ravioli dish the sauce was so delicious that it needed a spoon.",
                pt: "Joia escondida em Lagos. A comida estava incrível e o ambiente era tão relaxado, perfeito para uma noite de verão. O serviço foi muito bom. Fotos: atum grelhado com legumes e batatas (sabor incrível) e ravióli com abóbora e queijo e baunilha e limão. Gastamos 45-50 euros por pessoa, com entradas e uma garrafa de vinho. É o tipo de lugar para sair para uma noite adorável. Para o prato de ravióli, o molho era tão delicioso que precisava de uma colher."
            },
            rating: 5,
            image: "/images/reviewers/reviewer2.jpg",
            isLocalGuide: true,
            sourceUrl: "https://maps.app.goo.gl/C8jacYjtJremDV2v6"
        },
        {
            name: "Thomas Schmidt",
            location: {
                en: "Visitor",
                pt: "Visitante"
            },
            comment: {
                en: "Omg, if you want a Michelin star meal without the cost, this is it! We are traveling the whole country of Portugal and this is so far the best meal we have had! Try the goat cheese appetizer, the bass entree and duck entree were amazing. Nothing like we ever had before!",
                pt: "Meu Deus, se você quiser uma refeição com estrela Michelin sem o custo, é isso! Estamos viajando por todo o país de Portugal e esta é até agora a melhor refeição que tivemos! Experimente a entrada de queijo de cabra, o prato principal de robalo e o prato principal de pato eram incríveis. Nada parecido com o que já tivemos antes!"
            },
            rating: 5,
            image: "/images/reviewers/reviewer3.jpg",
            isLocalGuide: false,
            sourceUrl: "https://maps.app.goo.gl/TGzxWb47dPJ6MYvz7"
        },
        {
            name: "Robert Wilson",
            location: {
                en: "Local Guide",
                pt: "Guia Local"
            },
            comment: {
                en: "\"No Patio\" is a beautiful Lagos restaurant with delicious dishes and personable servers. We had a reservation for two and were seated immediately upon arriving. In Portuguese, the restaurant's name means \"on the patio,\" and even though there are tables indoors, the best ambiance is outdoors at night surrounded by soft lighting and trees. We ordered the duck with carrot puree and boiled potatoes and tuna with mango and creme brulee for dessert, all accompanied by Portuguese red wine. The food is fantastic and you will not regret eating at No Patio. A note to visitors is that we went in October when the weather is mild. I can see it getting hot during the summer months, but it's all part of the experience of an outdoor dinner.",
                pt: "\"No Patio\" é um lindo restaurante em Lagos com pratos deliciosos e garçons simpáticos. Tínhamos uma reserva para dois e fomos sentados imediatamente ao chegar. Em português, o nome do restaurante significa \"no pátio\", e embora haja mesas no interior, o melhor ambiente é ao ar livre à noite, rodeado por iluminação suave e árvores. Pedimos o pato com purê de cenoura e batatas cozidas e atum com manga e creme brulée para sobremesa, tudo acompanhado de vinho tinto português. A comida é fantástica e você não se arrependerá de comer no No Patio. Uma observação para os visitantes é que fomos em outubro, quando o tempo é ameno. Posso ver que fica quente durante os meses de verão, mas tudo faz parte da experiência de um jantar ao ar livre."
            },
            rating: 5,
            image: "/images/reviewers/reviewer4.jpg",
            isLocalGuide: true,
            sourceUrl: "https://maps.app.goo.gl/Lhot7BXBjMUMQ2tv9"
        },
        {
            name: "Sofia Almeida",
            location: {
                en: "Visitor",
                pt: "Visitante"
            },
            comment: {
                en: "Another great Wine Dinner at No Pátio, the food is simply great and everyone is awesome and attentive. I want to see this place in the summer, thank you",
                pt: "Outro ótimo Jantar com Vinho no No Pátio, a comida é simplesmente ótima e todos são incríveis e atenciosos. Quero ver este lugar no verão, obrigado"
            },
            rating: 5,
            image: "/images/reviewers/reviewer5.jpg",
            isLocalGuide: false,
            sourceUrl: "https://maps.app.goo.gl/x18cufFadaAvjDr2A"
        },
        {
            name: "David Miller",
            location: {
                en: "Local Guide",
                pt: "Guia Local"
            },
            comment: {
                en: "Wow. Just.. wow. I've had Michelin restaurants all over the world and this place renewed my passion for food in a single meal. The owner was our server, and each dish was truly remarkable. Her every recommendation was spot on. I almost got emotional over the Stone Bass fish, and I'd even place it in the top 3 dishes I've ever had. The decor is splendid and the service is also incredible. If you're shopping for dinner spots in Lagos this is a no brainer. It's fine dining at very reasonable prices.",
                pt: "Uau. Simplesmente.. uau. Já estive em restaurantes com estrela Michelin em todo o mundo e este lugar renovou minha paixão pela comida em uma única refeição. A proprietária foi nossa garçonete, e cada prato foi verdadeiramente notável. Cada recomendação dela foi certeira. Quase fiquei emocionado com o peixe Robalo, e eu até o colocaria entre os 3 melhores pratos que já comi. A decoração é esplêndida e o serviço também é incrível. Se você está procurando lugares para jantar em Lagos, é uma escolha óbvia. É um restaurante sofisticado a preços muito razoáveis."
            },
            rating: 5,
            image: "/images/reviewers/reviewer6.jpg",
            isLocalGuide: true,
            sourceUrl: "https://maps.app.goo.gl/AVuqqS2YecqdTPMW8"
        }
    ],

    // Reviews
    rating: 4.8
};

export default restaurantConfig;